import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { AppTextService } from '@fi-shared/app-text';

export interface IFiTransferOwnershipConfirmDialogComponentData {
    transferredItemsTotal: number;
    sourceUserName: string;
    targetUserName: string;
}

@Component({
    selector: 'fi-transfer-ownership-confirm-dialog',
    template: `
        <div class="transfer-ownership-confirm-description-wrapper">
            <p class="transfer-ownership-confirm-description">
                {{
                    'ownership.confirm_transfer_dialog_p1'
                        | fiAppText
                            : {
                                  '{0}': data.transferredItemsTotal,
                                  '{1}': data.sourceUserName,
                                  '{2}': data.targetUserName,
                              }
                }}
            </p>
            <p class="important-text transfer-ownership-confirm-description">
                {{ 'ownership.confirm_transfer_dialog_p2' | fiAppText }}
            </p>
            <p class="transfer-ownership-confirm-description">
                {{ 'ownership.confirm_transfer_dialog_p3' | fiAppText: { '{0}': confirmTextToInput } }}
            </p>
        </div>

        <mat-form-field appearance="outline" class="fi-rounded-form-field">
            <mat-label>{{ 'common.type_here' | fiAppText }}</mat-label>
            <input type="text" matInput [(ngModel)]="confirmText" />
        </mat-form-field>
    `,
    styleUrl: './fi-transfer-ownership-confirm-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-transfer-ownership-dialog' },
    standalone: false,
})
export class FiTransferOwnershipConfirmDialogComponent extends FiDialogsContentBase<
    IFiTransferOwnershipConfirmDialogComponentData,
    void
> {
    readonly appTextService: AppTextService = inject(AppTextService);
    readonly confirmTextToInput: string = this.appTextService.get('common.confirm').toUpperCase();

    confirmText: string;

    isYesButtonDisabled(): boolean {
        return this.confirmTextToInput !== this.confirmText;
    }
}
